<template>
     <div class="todo-footer__tab todo-footer__tab--mobile">
       <button class="todo-footer__tab__btn todo-footer__tab__btn--active"
          @click="allBtnClick"
          ref="allBtn"
       >All</button>
       <button class="todo-footer__tab__btn"
          @click="activeBtnClick"
          ref="activeBtn"
       >Active</button>
       <button class="todo-footer__tab__btn"
          @click="completedBtnClick"
          ref="completedBtn"
       >Completed</button>
     </div>
</template>

<script>
   export default {
     name: "TheFooterTabsMobile",
     methods: {
        allBtnClick: function($event) {
            $event.target.classList.add('todo-footer__tab__btn--active')
            this.$refs.activeBtn.classList.remove('todo-footer__tab__btn--active')
            this.$refs.completedBtn.classList.remove('todo-footer__tab__btn--active')
            this.$emit('all-todos')
        },
        activeBtnClick: function($event) {
            $event.target.classList.add('todo-footer__tab__btn--active')
            this.$refs.allBtn.classList.remove('todo-footer__tab__btn--active')
            this.$refs.completedBtn.classList.remove('todo-footer__tab__btn--active')
            this.$emit('active-todos')
        },
        completedBtnClick: function($event) {
            $event.target.classList.add('todo-footer__tab__btn--active')
            this.$refs.allBtn.classList.remove('todo-footer__tab__btn--active')
            this.$refs.activeBtn.classList.remove('todo-footer__tab__btn--active')
            this.$emit('completed-todos')
        }
     }
   }
</script>

<style>
/* most of the styles for this component are in the "BaseMainTodoContainerFooterTabsDesktop.vue" component */

.todo-footer__tab--mobile {
    display: flex;
    align-items: center;
    justify-content: center;

    width: clamp(200px, var(--main-width), 540px);
    height: 48px;

    margin-top: 16px;
    background-color: var(--bg-todo-clr);
    font-size: var(--todo-footer-font-size);
    border-radius: var(--border-radius);
    color: var(--todo-footer-clr);

    display: none; /* shows only on mobile */
}

@media screen and (max-width: 33.125em) { /* 530px */
    .todo-footer__tab--mobile { display: flex }
}
</style>